export default __webpack_public_path__ + "static/media/1.051c1000.svg";